import { cn } from "@/lib/utils";
import { STATUS_STYLES, STATUS_LABELS } from "@/lib/format";

export default function StatusBadge({ status, className }) {
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium border",
      STATUS_STYLES[status] || STATUS_STYLES.booked, className)}>
      {STATUS_LABELS[status] || status}
    </span>
  );
}
